module.exports = __webpack_public_path__ + "091d2d22c800908b009d915475881b60.svg";